// extracted by mini-css-extract-plugin
module.exports = {"FeedbackTabContainer":"FeedbackTab_FeedbackTabContainer__zevCf","Tabs":"FeedbackTab_Tabs__GQZBl"};